// extracted by mini-css-extract-plugin
export default {"formHeader":"EditPagesHead_formHeader__-aEqF","headerButton":"EditPagesHead_headerButton__vKg8e","title":"EditPagesHead_title__mxsRO"};